window.addEventListener('DOMContentLoaded', () =>
{
  const regionBtn = document.querySelector('.region__name');
  if(!regionBtn)
  {
    return;
  }
  const regionList = document.querySelector('.region__container');
  const regionContainer = document.querySelector('.region');
  const modalOverlay = document.querySelector('.modal-overlay');

  regionBtn.addEventListener('click', () =>
  {
    if(!regionList.classList.contains('overlay-visible'))
    {
      openRegions();
    }
    else
    {
      closeRegions();
    }
  });

  const openRegions = () =>
  {
    regionList.classList.add('overlay-visible', 'active');
    regionContainer.classList.add('region--open');
    document.body.classList.add('scroll-lock');
    document.body.addEventListener('click', onClickOutsideRegions);
    modalOverlay.classList.remove('visually-hidden');
  };

  const closeRegions = () =>
  {
    modalOverlay.classList.add('visually-hidden');
    regionList.classList.remove('overlay-visible', 'active');
    regionContainer.classList.remove('region--open');
    document.body.classList.remove('scroll-lock');
    document.body.removeEventListener('click', onClickOutsideRegions);
  };

  const onClickOutsideRegions = (e) =>
  {
    if(!e.target.closest('.region'))
    {
      closeRegions();
    }
  };
});
